module.exports = __webpack_public_path__ + "img/search-icon-dark-blue.b82385fa.svg";